<div class="" fxLayout="column" fxLayoutAlign="start center">
  <ng-container *ngIf="data.fechasRecordatorios.length > 0; else sinReco">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TIUTLOLISTA' | translate}}</h2>
    <mat-dialog-content class="mat-typography">
      <mat-list>
        <mat-list-item *ngFor="let fecha of data.fechasRecordatorios; last as last">
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <h4 mat-line>{{fecha | slice: 0:10 | date:"fullDate":'':idiomaActual}}</h4>
          <!-- <p mat-line class="demo-2"> {{folder.updated}} </p> -->
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </mat-list>
    </mat-dialog-content>
  </ng-container>
  <ng-template #sinReco>
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NORECOS' | translate}}</h2>
  </ng-template>
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'SHEDULE2_0.CERRAR' | translate}}
    <mat-icon class="ml-20">clear</mat-icon>
  </button>
</div>
